import client from '../client'
import { GetAuthRes } from './types'

export async function getAuth() {
  const response = await client.get<GetAuthRes>(`auth-api/v1/auth/user/detail`)
  return response.data
}
